import Breadcrumb from '@/components/base/Breadcrumb';

type Props = {
  eyebrow: string;
  title: string;
  description: string;
  breadcrumb: { label: string; to?: string }[];
};

export default function PageHeader({ eyebrow, title, description, breadcrumb }: Props) {
  return (
    <section className="w-full bg-background-100 border-b border-background-200/70">
      <div className="w-full px-4 md:px-8 py-8 md:py-12">
        <Breadcrumb items={breadcrumb} />
        <div className="mt-5 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-2.5">
              <span className="w-6 h-px bg-accent-500"></span>
              <span className="text-[11px] tracking-[0.24em] uppercase text-accent-600 font-label">
                {eyebrow}
              </span>
            </div>
            <h1 className="text-2xl md:text-4xl font-semibold tracking-wide">{title}</h1>
            <p className="mt-3 text-sm md:text-base text-secondary-600 leading-7">{description}</p>
          </div>
          <div className="hidden lg:flex items-center gap-2 text-[11px] text-secondary-500 font-label tracking-wide whitespace-nowrap">
            <i className="ri-bookmark-line w-4 h-4 flex items-center justify-center"></i>
            琉璃神社 · 内容档案
          </div>
        </div>
      </div>
    </section>
  );
}